/**
 * NewSubscriber.js
 * File cloned from account/NewAccount.js and modified
 */
import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import { Button, Typography, TextField, LinearProgress, Dialog } from '@material-ui/core';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withSnackbar } from 'notistack';
import { cloneDeep } from 'lodash';
import moment from 'moment-timezone';

import Messenger from 'components/utils/Messenger';
import Constants from 'components/utils/constants';
import DatePicker from 'components/utils/DatePicker';
import { validator } from 'components/utils/validator';
import mapStateToProps from 'reducers/actions/stateToProps';
import { ListItemHandler } from 'chits-data/dist';
import { SubscriberHandler } from 'chits-data/dist';

import { SubscriberStyle } from './SubscriberStyle';
import { mapSubscriber, subscriberObject } from 'components/mapper/objectMapping';

class NewSubscriber extends Component {
    constructor(props) {
      super(props)
      this._handler = new SubscriberHandler();
      this._handlerListItem = new ListItemHandler();
      this.handleAccountCurrFieldChange = this.handleAccountCurrFieldChange.bind(this)
      this.handleAccountTypeFieldChange = this.handleAccountTypeFieldChange.bind(this)
    }

    state = {
		currencies: [],
		// accountTypes: ['SUB'],
		sqlErrorMessage: '',
		actionInProgress      : {
			openLinearLoading   : false,
			disableActionButton : false
		},
		accountMap : mapSubscriber(this.props.account),
        accountArchiveConfirmation: false,
        isReactivating: false,
        page : 0
    };

	componentDidMount = () => {
        this._handler.componentDidMount();
		this._isMounted = true;

		if (this._isMounted) {
			this.handleGetCurrencies();
			// this.handleGetAcctTypes();
		}
    };

    componentWillUnmount = () => {
        this._handler.componentWillUnmount();
    }

    handleGetCurrencies = async () => {
        // console.log('handleGetCurrencies')
        this._handlerListItem.getCurrencies()
		.then((data) => {
            // console.log('returned to New Account', data);
            this.setState({ currencies: data });
		})
		.catch((err) => {
            console.error(err)
			console.log('error while fetching currencies:' + err.message);
            this.setState({ currencies: [] });
		})
	}

	// handleGetAcctTypes = async () => {
    //     this._handlerListItem.getAcctTypes()
	// 	.then((data) => {
    //         this.setState({ accountTypes: data });
	// 	})
	// 	.catch((err) => {
    //         console.error(err)
	// 		console.log('error while fetching account types:' + err.message);
    //         this.setState({ accountTypes: [] });
	// 	})
	// }

    handleAllAccountFieldValidation = (action) => {
        // console.log("action", action)
		let _account = this.state.accountMap;
        let allPassed = true;

        // console.log("_account", _account)

        Object.keys(_account).forEach((name)=>{
            let _field = _account[name];
            let { rules, value, hasErrors } = _field;
            if (rules) {
                let _rules = Object.keys(rules);
                //TODO: Required property shouldn't be inside rules[]. Change in objectMapping.js
                let _isRequired = rules.required; 
                for (let _rule of _rules) {
                    if (rules[_rule] && _rule in validator) {
                        let validation = validator[_rule](value, rules[_rule]);
    
                        if (!validation.passed) {
                            hasErrors.error = true;
                            hasErrors.message = validation.message;
                            // Only if this field is required; then mark allPass as false;
                            if (_isRequired) {
                                allPassed = false;
                            }
                            break;
                        }
                        else {
                            hasErrors.error = false;
                            hasErrors.message = validation.message;
                        }
                    }
                }
            }
        })

		this.setState({
			accountMap : _account,
		});
        if (allPassed) {
            if(_account.type && _account.type.value === 'CHIT') {
                this.props.onInitChitInfo(_account);
            } else {
                // if (action === 'new') {
                    this.handleCreateAccount();
                // } else if (action === 'update') {
                //     this.handleUpdateAccount();
                // }
            }
        } else {
            let warning = Object.entries(_account).reduce((warn, [field, data])=>{
                warn += `\n${field} = [${data.value}] ${data.hasErrors.error ? data.hasErrors.message : 'OK'}\n`;
                return warn;
            },'');
            this._handler.showWarn('some data validations failed. Please check console.')
            console.log('some data validations failed.', warning);
        }
    }

	handleAccountFieldValidation = (e) => {
		let _account = this.state.accountMap;
		let _field = _account[e.target.name];
		let rules = Object.keys(_field.rules);

		_field.value = e.target.value;

		if (rules) {
			for (let rule of rules) {
				if (_field.rules[rule] && rule in validator) {
					let validation = validator[rule](_field.value, _field.rules[rule]);

					if (!validation.passed) {
						_field.hasErrors.error = true;
						_field.hasErrors.message = validation.message;

						break;
					}
					else {
						_field.hasErrors.error = false;
						_field.hasErrors.message = validation.message;
					}
				}
			}
		}

		this.setState({
			accountMap : _account
		});
    }

	handleCreateAccount = async () => {
		let _account = this.state.accountMap;
        // this._handler.nav.setActionInProgress();
		
		let preparedReleaseObject = this._handler.prepareObjectForSaving(_account);
        // console.log(`preparedReleaseObject: `, preparedReleaseObject);
		let responseErr = '';
		this._handler.getInstance()
			.post(`${Constants.URLs.SUBSCRIBERS}`, preparedReleaseObject)
			.then(async (response) => {
                this.props.enqueueSnackbar('Account created successfully', {
                    variant : 'success'
                });
                return this._handler.getSubscribersCached(true).then(()=>{
                    _account = cloneDeep(subscriberObject);
                })
                
			})
			.catch((error) => {
                console.log(error.response);
                if (error.response.data && error.response.data.message.startsWith('E11000 duplicate key error')) {
                    this.props.enqueueSnackbar('Error: Account Code already exists. Please fix and try again.', {
                        variant : 'error'
                    });
                    responseErr = 'Cell number found for another subscriber. Please enter unique one.';
                } else {
                    responseErr = error.message;
                    this.props.enqueueSnackbar('An error occurred from the server', {
                        variant : 'error'
                    });
                }
			})
			.finally(()=>{
                // this._handler.nav.unsetActionInProgress();
				this.setState({
					sqlErrorMessage  : responseErr,
					accountMap: _account,
				});
				if (responseErr === '') {
					this.props.onSubmit();
				}
			})
	};

    handleArchivingSubscriber = async (_isReactivating=false) => {
        this.setState({ 
            accountArchiveConfirmation: false
        })
        this.props.onBusy(true);
        let _id = this.props.account._id;
        if (!_id) {
            this.props.enqueueSnackbar('Account Id missing to update', {
                variant : 'warning'
            });
            return;
        }
        let hooks = {
            // before: () => {},
            after: () => {
                this._handler.showSuccess(`Account ${(_isReactivating ? 'reactivated' : 'archived')} successfully.`);
            },
            // error: () => {}
        }
        let _request;
        if (_isReactivating) {
            _request = this._handler.unArchiveSubscriber(_id, hooks);
        } else {
            _request = this._handler.archiveSubscriber(_id, hooks);
        }
        _request.then((ac)=>{
            // console.log("ac", ac);
            //just re-load accounts to cache.
            return this._handler.getSubscribersCached(true).then(()=>{
                window.open('/dashboard',"_self");
            })
        }).finally(()=>this.props.onBusy(false))
        
    }
    
    handleUpdateAccount = async () => {
        let _id = this.props.account._id;
        if (!_id) {
            this.props.enqueueSnackbar('Account Id missing to update', {
                variant : 'warning'
            });
            return;
        }



        let _account = this.state.accountMap;
        let allPassed = true;

        // console.log("_account", _account)

        Object.keys(_account).forEach((name)=>{
            let _field = _account[name];
            let rules = Object.keys(_field.rules);
            // console.log("_field", _field)
            // console.log("rules", rules);
            //TODO: Required property shouldn't be inside rules[]. Change in objectMapping.js
            let _isRequired = _field.rules.required;

            if (rules) {
                for (let rule of rules) {
                    if (_field.rules[rule] && rule in validator) {
                        let validation = validator[rule](_field.value, _field.rules[rule]);
    
                        if (!validation.passed) {
                            _field.hasErrors.error = true;
                            _field.hasErrors.message = validation.message;

                            // Only if this field is required; then mark allPass as false;
                            if (_isRequired) {
                                allPassed = false;
                            }
    
                            break;
                        }
                        else {
                            _field.hasErrors.error = false;
                            _field.hasErrors.message = validation.message;
                        }
                    }
                }
            }
        })

		this.setState({
			accountMap : _account,
		});
        if (allPassed) {
            // if(_account.type.value === 'CHIT') {
            //     this.props.onInitChitInfo(_account);
            // } else {
                // if (action === 'new') {
                    // this.handleCreateAccount();
                // } else if (action === 'update') {
                //     this.handleUpdateAccount();
                // }
            // }

            let payloadAccount = this._handler.prepareObjectForSaving(this.state.accountMap);
            // this._handler.nav.setActionInProgress();
            
            // this._handler.getInstance()
            //     .patch(`${Constants.URLs.SUBSCRIBERS}/` + _id, payloadAccount)
            this._handler.patchSubscriber(_id, payloadAccount)
                .then((response) => {
                    if (response.status === 400) {
                        this.setState({
                            sqlErrorMessage  : response.data.message,
                        });
                    }
                    else {
                        this.props.enqueueSnackbar('Account updated successfully', {
                            variant : 'success'
                        });
                        // this.setState({ 
                        //     openOverlay: true, 
                        // });
                    }
                }).finally(async ()=>{
                    // this._handler.nav.unsetActionInProgress();
                    
                    // TODO: Bulk update any entities/field related to subscriber currency
                    // if (this.props.account.curr !== payloadAccount.curr) {
                    //     // console.log('currency updated, refreshing transactions')
                    //     let payload = {
                    //         account: _id,
                    //         updates: {	
                    //             curr : payloadAccount.curr
                    //         }
                    //     }
                    //     this._handler.getInstance()
                    //         .post(`${Constants.URLs.TRANS}/bulkaccountupdate/ac/${_id}`, payload)
                    //         .then(async (response) => {
                    //             if (response.status === 400) {
                    //                 this.props.enqueueSnackbar('Error: An internal error occured while refreshing transactions.', {
                    //                     variant : 'error'
                    //                 });
                    //             } else {
                    //                 this.props.enqueueSnackbar('Transactions currency updated successfully', {
                    //                     variant : 'success'
                    //                 });
                    //             }
                    //         }).catch((error) => {
                    //             console.log(error);
                    //             this.props.enqueueSnackbar('An error occurred from the server while refreshing transactions', {
                    //                 variant : 'error'
                    //             });
                    //         }).finally(()=>this.props.onSubmit())
                    // } else {
                    //     this.props.onSubmit();
                    // }
                    this.props.onSubmit();
                })





        } else {
            let warning = Object.entries(_account).reduce((warn, [field, data])=>{
                warn += `\n${field} = [${data.value}] ${data.hasErrors.error ? data.hasErrors.message : 'OK'}\n`;
                return warn;
            },'');
            this._handler.showWarn('some data validations failed. Please check console.')
            console.log('some data validations failed.', warning);
        }




    };
  
  
	handleAccountCurrFieldChange(e) {
		let _account = this.state.accountMap;
		_account.curr.value = e.target.value;
		this.setState({ accountMap: _account });
	}
	handleAccountTypeFieldChange(e) {
		let _account = this.state.accountMap;
		_account.type.value = e.target.value;
		this.setState({ accountMap: _account });
	}

    getTextField(fieldName) {
        const {classes} = this.props;
        let {accountMap} = this.state;
        let field = accountMap[fieldName];
        if (!field) return;
        let {alias, value, hasErrors, type, rules} = field;
        return (
            <TextField
                name={fieldName}
                label={alias}
                data-cy={`txt${fieldName}`}
                className={classes.textField}
                value={value ? value : ""}
                type={type ? type : 'text'}
                required={rules.required}
                onChange={this.handleAccountFieldValidation}
                variant="standard" // opt: standard, outlined or filled
                helperText={hasErrors.message}
                inputProps={{
                    readOnly: this.props.readOnly,
                }}
                InputProps={{
                    className: (this.props.readOnly) ? 'Mui-disabled' : undefined,
                }}
            />
        )
    }

    renderPageForm() {
        let _this = this;
        const {classes} = this.props;
        let {accountMap} = this.state;
        let _date = accountMap['date'];
        // let _curr = accountMap['curr'];
        // let _acCurr = currencies.filter(type=>type.code===_curr.value)[0];
        return (
            <Grid item md={12} lg={12} xs={12}>
                    {this.getTextField('fname')}
                    {this.getTextField('lname')}
                    {this.getTextField('cell')}
                    {this.getTextField('email')}
                    {/* <Select
                        name="select-currency"
                        data-cy="ddAccountSelectCurrency"
                        value={_acCurr ? _acCurr.code : ""}
                        className={classes.textField}
                        style={{paddingTop: '20x' }}
                        onChange={this.handleAccountCurrFieldChange}
                        disabled={this.props.readOnly}
                        defaultValue = ""
                        >
                            {currencies && currencies.map((curr, index) => {
                                return (
                                    <MenuItem
                                        key={`type-${curr.code}`}
                                        value={curr.code}>
                                        {`${curr.code}`}
                                    </MenuItem>
                                );
                            })}
                    </Select> */}
                    {!window.isAndroid() && 
                        <TextField
                            name={'date'}
                            label={_date.alias}
                            data-cy={"txtAccountdate"}
                            className={classes.textField}
                            value={_date.value ? _date.value : ""}
                            type={_date.type ? _date.type : 'text'}
                            required={true}
                            onChange={this.handleAccountFieldValidation}
                            variant="standard" // opt: standard, outlined or filled
                            helperText={_date.hasErrors.message}
                            inputProps={{
                                readOnly: this.props.readOnly,
                            }}
                            InputProps={{
                                className: (this.props.readOnly) ? 'Mui-disabled' : undefined,
                            }}
                        />
                    }
                    {window.isAndroid() && <label htmlFor="newSubscriberDate">Date:</label>}
                    {window.isAndroid() && <DatePicker 
                        id="newSubscriberDate"
                        onSetDate={(d)=>{
                            let _ac = accountMap;
                            _ac.date.value = moment(d).format('YYYY-MM-DD');
                            // console.log("date selected", JSON.stringify(_ac.date));
                            _this.setState({ accountMap: _ac })
                        }}
                        label={accountMap.date.alias}
                        value={accountMap.date.value}
                        inputProps={{
                            readOnly: this.props.readOnly,
                        }}
                        InputProps={{
                            className: (this.props.readOnly) ? 'Mui-disabled' : undefined,
                        }}
                    />}
                </Grid>
        )
    }

    
    renderActions() {
        const {classes} = this.props;
        let {accountMap} = this.state;
        //let isActive = (accountMap.status.value==="ac");
        let isArchived = (accountMap.status.value==="cl");
        let isChit = (accountMap.type && accountMap.type.value === 'CHIT');
        return (
            <Grid item md={12} lg={12} xs={12} >
                <div className={classes.newReleaseModalActions} data-cy="mdlCreateNewReleaseActions"  style={{ margin: '0px', padding: '2px'}}>
                    {!this.props.hideActions && this.props.readOnly && <Button   style={{ padding: '4px'}}
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        data-cy="mdlCreateNewSubscriberActionEdit"
                        onClick={() => this.props.onEnableEdit()}>
                        Edit
                    </Button>}
                    {!this.props.hideActions && !this.props.readOnly && <Button
                        variant="contained"
                        color="primary"
                        className={classes.button}
                        data-cy="mdlCreateNewSubscriberActionCancel"
                        onClick={() => this.props.onCancel()}>
                        Cancel
                    </Button>}
                    {!this.props.hideActions && !this.props.readOnly && !this.props.modeUpdate && <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        data-cy="mdlCreateNewSubscriberActionSubmit"
                        disabled={this.state.actionInProgress.disableActionButton}
                        onClick={() =>this.handleAllAccountFieldValidation()}
                        >
                        {isChit ? `Next` : `Submit`}
                    </Button>}
                    {!this.props.hideActions && !this.props.readOnly && this.props.modeUpdate && <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        data-cy="mdlCreateNewSubscriberActionUpdate"
                        disabled={this.state.actionInProgress.disableActionButton}
                        onClick={() => this.handleUpdateAccount()}
                        >
                        Update
                    </Button>}
                    {!this.props.hideActions && 
                        !this.props.readOnly && 
                        this.props.modeUpdate && 
                        !this.props.hideArchive && 
                        !isArchived && <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        data-cy="mdlCreateNewSubscriberActionArchive"
                        disabled={this.state.actionInProgress.disableActionButton}
                        onClick={() => this.setState({ accountArchiveConfirmation: true, isReactivating: false })}
                        >
                        Archive
                    </Button>}
                    {!this.props.hideActions && 
                        !this.props.readOnly && 
                        this.props.modeUpdate && 
                        !this.props.hideArchive && 
                        isArchived && <Button
                        variant="contained"
                        color="secondary"
                        className={classes.button}
                        data-cy="mdlCreateNewSubscriberActionActivate"
                        disabled={this.state.actionInProgress.disableActionButton}
                        onClick={() => this.setState({ accountArchiveConfirmation: true, isReactivating: true })}
                        >
                        Re-activate Account
                    </Button>}
                </div>
            </Grid>
        )
    }

    renderForm() {
        const {classes} = this.props;
        return (
            <Grid container className={classes.newReleaseModal} data-cy="mdlCreateNewSubscriberGrid">
                <Grid item md={12} lg={12} xs={12}>
                    <Typography variant="h6" align="center">
                        {this.props.modeUpdate ? 'Update Contact' : 'Add a Contact'}
                    </Typography>
                </Grid>

                {this.renderPageForm()}
                
                <Grid item md={12} lg={12} xs={12}>
                    <Typography variant="caption" align="center" className={classes.sqlErrorMessage}>
                        {this.state.sqlErrorMessage}
                    </Typography>
                </Grid> 

                {this.renderActions()}

                {this.state.actionInProgress.openLinearLoading && (
                    <LinearProgress color="secondary" variant="query" />
                )}
            </Grid>
        )
    }

    renderAsGrid() {
        let {isReactivating} = this.state;
        return (
            <div>
                {this.props.display && this.renderForm()}
                <Dialog
                    open={this.state.accountArchiveConfirmation}
                    style={{ padding: '30px' }} >
                    <Typography>
                        {Messenger.getAccountArchiveConfirmation(isReactivating)}
                    </Typography>
                    <Button 
                        color="secondary"
                        onClick={() => this.handleArchivingSubscriber(isReactivating)}>
                        Yes
                    </Button>
                    <Button  
                        color="primary"
                        onClick={() => this.setState({ accountArchiveConfirmation: false, isReactivating: false })}>
                        No
                    </Button>
                </Dialog>
            </div>
        )
    }

    renderAsDialog() {
        return (
            <Dialog
                open={this.props.display}
                onClose={() => {}}
                style={{margin: '10px'}}>
                {this.renderForm()}
            </Dialog>
        )
    }

    render() {
        if (this.props.asDialog) {
            return this.renderAsDialog();
        } 
        return this.renderAsGrid();
    }
}

NewSubscriber.propTypes = {
  classes: PropTypes.object.isRequired,
  display: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onInitChitInfo: PropTypes.func,
  modeUpdate:  PropTypes.bool.isRequired,
  onBusy: PropTypes.func,
  account: PropTypes.object,
  asDialog: PropTypes.bool.isRequired,
  readOnly: PropTypes.bool,
  onEnableEdit: PropTypes.func,
  hideActions: PropTypes.bool,
  hideArchive: PropTypes.bool
};

export default connect(mapStateToProps)(withSnackbar(withStyles(SubscriberStyle)(NewSubscriber)));
  